'use client';

import React, { useState } from 'react';
import OverviewTab from './OverviewTab';
import ReviewsTab from './ReviewsTab';
import PortfolioTab from './PortfolioTab';

const TABS = [
  { id: 'tab-overview', label: 'Overview', key: 'overview' },
  { id: 'tab-reviews', label: 'Reviews (214)', key: 'reviews' },
  { id: 'tab-portfolio', label: 'Portfolio', key: 'portfolio' },
];

export default function ProfileTabs() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div>
      {/* Tab bar */}
      <div className="flex items-center gap-1 bg-white rounded-xl border border-gray-100 p-1 mb-6 shadow-card">
        {TABS?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.key)}
            className={`flex-1 py-2 px-4 rounded-lg text-sm font-semibold transition-all duration-150 ${
              activeTab === tab?.key
                ? 'bg-plum-800 text-white shadow-sm'
                : 'text-gray-500 hover:text-gray-800 hover:bg-gray-50'
            }`}
          >
            {tab?.label}
          </button>
        ))}
      </div>
      {/* Tab content */}
      {activeTab === 'overview' && <OverviewTab />}
      {activeTab === 'reviews' && <ReviewsTab />}
      {activeTab === 'portfolio' && <PortfolioTab />}
    </div>
  );
}